import { useEffect, useRef, useState } from 'react';

const PATH_LENGTH = 1000;

export function MockupThread() {
  const [progress, setProgress] = useState(0);
  const [enabled, setEnabled] = useState(false);
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobile = window.innerWidth < 1024;
    if (reduce || mobile) return;
    setEnabled(true);

    function compute() {
      const start = document.getElementById('thread-start');
      const end = document.getElementById('thread-end');
      if (!start || !end) return;
      const startY = start.getBoundingClientRect().top + window.scrollY;
      const endY = end.getBoundingClientRect().top + window.scrollY;
      const headY = window.scrollY + window.innerHeight * 0.5;
      const p = Math.max(0, Math.min(1, (headY - startY) / (endY - startY)));
      setProgress(p);
    }

    function onScroll() {
      if (rafRef.current != null) return;
      rafRef.current = requestAnimationFrame(() => {
        rafRef.current = null;
        compute();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    compute();
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (rafRef.current != null) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  if (!enabled) return null;

  const offset = (1 - progress) * PATH_LENGTH;

  return (
    <svg
      aria-hidden
      className="mockup-thread"
      width="2"
      height="100vh"
      viewBox="0 0 2 1000"
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient id="threadGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--color-accent)" />
          <stop offset="75%" stopColor="var(--color-accent)" />
          <stop offset="100%" stopColor="var(--color-gold)" />
        </linearGradient>
      </defs>
      <line
        x1="1" y1="0" x2="1" y2="1000"
        stroke="url(#threadGrad)"
        strokeWidth="1"
        strokeDasharray={PATH_LENGTH}
        strokeDashoffset={offset}
      />
    </svg>
  );
}
